import { Row, Col, Image } from "../../bootstrap.js";
import * as data from "./groupMembersData.js";
import { GroupMembers } from "./GroupMembers.js";
import { GroupMembers2 } from "./GroupMembers2.js";
import { GroupMembersAccess } from "./GroupMembersAccess.js";
import { PrevMembers } from "./PrevMembers.js";
import "./group.css";
import { useMediaQuery } from "usehooks-ts";
import { Mona } from "./Mona.js";

export function Group() {
  const isMobile2 = useMediaQuery("(max-width: 992px)");

  const videoHero = (
    <div className="videoHeroWrapper">
      <div className="videoHeroContent">
        <div className="videoText">
          <h2>Collaboration, Curiosity, Community</h2>
          <p>
            The foundations of our student research culture.
            We value open communication, active mentorship, and a spirit of curiosity. Watch how our research students come together across disciplines to make science more engaging — and more human.
          </p>
        
          <p style={{ marginTop: "16px", marginBottom: "16px" }}>
            Want to know more about the students working in our lab?{" "}
            <a href="/interview" style={{ display: "inline-block", padding: "5px 16px", border: "2px solid currentColor", borderRadius: "20px", fontWeight: "600", textDecoration: "none", marginLeft: "0px" }}>Meet the students &#8594;</a>
          </p>

        </div>
        <div className="videoBox">
          <iframe
            src="https://www.youtube.com/embed/L_naD6qyzzE?start=1"
            title="YouTube video player"
            className="decoratedMedia"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          <span className="youtube-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
            YouTube
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {/* SWAPPED ORDER: group photo first, then video */}
      {isMobile2 ? (
        <>
          {/* Group hero first (mobile) */}
          <div className="groupHero">
            <header>
              <h3 className="labMembersTop">Group</h3>
            </header>
            <Row className="heroGroup">
              <Col>
                <Image
                  src="/images/Group/comebinelabstudents.jpg"
                  className="img-fluid groupPicHero"
                  alt="Group members all standing in a line with one holding a cake."
                />
              </Col>
            </Row>
          </div>

          {/* Video second (mobile) */}
          {videoHero}

          <div className="groupContainer">
            <header><h3 className="labMembers">Principal Investigator</h3></header>
            <section><Mona members={data.PI} /></section>

            <header><h3 className="labMembers">PhD Group Members</h3></header>
            <section><GroupMembers members={data.PhDStudents} /></section>

            <header><h3 className="labMembers">Post Doctoral Group Members</h3></header>
            <section><GroupMembers2 members={data.postdoctoral} /></section>

            <header><h3 className="labMembers">Graduate Group Members</h3></header>
            <section><GroupMembers2 members={data.graduateStudents} /></section>

            <header><h3 className="labMembers">Co-op Members</h3></header>
            <section><GroupMembers2 members={data.coopStudents} /></section>

            <header><h3 className="labMembers">Undergraduate Group Members</h3></header>
            <section><GroupMembers2 members={data.undergraduateStudents} /></section>

            <header><h3 className="labMembers">High School Group Members</h3></header>
            <section><GroupMembers2 members={data.highschoolStudents} /></section>

            <header><h3 className="labMembers">Access Assistants</h3></header>
            <section><GroupMembersAccess members={data.accessAssistants} /></section>
          </div>

          <div className="alumniBG">
            <header><h3 className="labMembers">PhD Alumni</h3></header>
            <section><PrevMembers members={data.phdAlumni} /></section>

            <header><h3 className="labMembers">Alumni</h3></header>
            <section><PrevMembers members={data.alumni} /></section>
          </div>
        </>
      ) : (
        <>
          {/* Group hero first (desktop) */}
          <div className="groupHero">
            <header>
              <h3 className="labMembers">Group</h3>
            </header>
            <section>
              <Row className="heroGroup">
                <Image
                  src="/images/Group/comebinelabstudents.jpg"
                  className="img-fluid groupPicHero"
                  alt="Group members."
                />
              </Row>
            </section>
          </div>

          {/* Video second (desktop) */}
          {videoHero}

          <div className="groupContainer">
            <header><h3 className="labMembers">Principal Investigator</h3></header>
            <section><Mona members={data.PI} /></section>

            <header><h3 className="labMembers">PhD Group Members</h3></header>
            <section><GroupMembers members={data.PhDStudents} /></section>

            <header><h3 className="labMembers">Post Doctoral Group Members</h3></header>
            <section><GroupMembers2 members={data.postdoctoral} /></section>

            <header><h3 className="labMembers">Graduate Group Members</h3></header>
            <section><GroupMembers2 members={data.graduateStudents} /></section>

            <header><h3 className="labMembers">Co-op Members</h3></header>
            <section><GroupMembers2 members={data.coopStudents} /></section>

            <header><h3 className="labMembers">Undergraduate Group Members</h3></header>
            <section><GroupMembers2 members={data.undergraduateStudents} /></section>

            <header><h3 className="labMembers">High School Group Members</h3></header>
            <section><GroupMembers2 members={data.highschoolStudents} /></section>

            <header><h3 className="labMembers">Access Assistants</h3></header>
            <section><GroupMembersAccess members={data.accessAssistants} /></section>
          </div>

          <div className="alumniBG">
            <header><h3 className="labMembers">PhD Alumni</h3></header>
            <section><PrevMembers members={data.phdAlumni} /></section>

            <header><h3 className="labMembers">Alumni</h3></header>
            <section><PrevMembers members={data.alumni} /></section>
          </div>
        </>
      )}
    </div>
  );
}
